import BaseView from '../../../js/base-view';

export default class CurrencySelector extends BaseView {
	init() {
		this.refs = {
			toggle: this.el.querySelector('[data-currency-selector="toggle"] span'),
			options: this.el.querySelector('[data-currency-selector="options"]'),
		};

		this.on('update-currency', this.onChange.bind(this));
	}

	onChange() {
		window.fetch(`${window.supt.restAPI.root}/supt/v1/currency`, {
			credentials: 'same-origin',
			headers: {
				'X-WP-Nonce': window.supt.restAPI.nonce,
			}
		})
			.then((res) => res.json())
			.then((res) => {
				this.refs.toggle.textContent = res.currency;
				this.refs.options.innerHTML = res.options;
			});
	}
}
